module.exports = __webpack_public_path__ + "img/fun-time.4cbc133.png";